import { AppRouter } from './router/AppRouter';
import './App.css';
import './styles/cta-button.css';
import './styles/header-mobile-fix.css';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
